
  import { defineComponent, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import {
    TPortalUniqueVisitsCountTableItem,
    TStatisticsPortalFilter,
    TStatisticsPortalUniqueVisitsCountChartItem,
  } from '@/modules/admin/types/statistics/statistics-portal';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import { TChartBaseConfig } from '../charts/chartTypes';
  import StatisticsVerticalColumnChart from '../charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from '../StatisticsByTimeTabs.vue';
  import StatisticsTabs from '../StatisticsTabs.vue';

  export default defineComponent({
    name: 'StatisticsPortalUniqueVisitsCountTab',
    components: {
      TableTree,
      StatisticsByTimeTabs,
      StatisticsTabs,
      StatisticsVerticalColumnChart,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      tableConfig: TTableTreeConfig<TPortalUniqueVisitsCountTableItem>;
      chartConfigs: TChartBaseConfig<TStatisticsPortalUniqueVisitsCountChartItem>;
    } {
      return {
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Период/группа пользователей',
            },
            {
              field: 'uniqueVisitsCount',
              title: 'Количество уникальных пользователей / В\u00A0том\u00A0числе количество новых пользователей',
              textAlign: 'right',
              width: 340,
            },
          ],
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getUniqueVisitsCountTable,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setUniqueVisitsCountTable,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getUniqueVisitsCountTable,
          },
          pagination: {
            size: 12,
          },
        },

        chartConfigs: {
          storePaths: {
            action: STATISTICS_PORTAL_ACTIONS_NAME.getUniqueVisitsCountChartData,
            mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setUniqueVisitsCountChartData,
            getter: STATISTICS_PORTAL_GETTERS_NAME.getUniqueVisitsCountChartData,
          },
          labelKey: 'label',
          tooltip: {
            key: 'text',
          },
          columns: [
            {
              name: 'Количество уникальных пользователей',
              valueKey: 'countUniqueUsers',
            },
            {
              name: 'В том числе количество новых пользователей',
              valueKey: 'countNewUsers',
            },
          ],
        },
      };
    },
  });
